import { usStatesOptions } from "../../../../questionnaire/dropdownOptionDefs/UsStateOptions";

export type PersonnelInfoLayoutRowType = {
    id: number;
    label: string;
    name: string;
    required(state: any): boolean;
    type: string;
    dependencies?: Array<string>;
    show(state: any): boolean;
};

export const PersonnelInfoLayoutRows = {
    1: [
        {
            id: 1,
            label: "First Name",
            name: "firstName",
            required: (state: any) => {
                return true;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
        {
            id: 2,
            label: "Middle Name",
            name: "middleName",
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return !state.isDrVenCol;
            },
        },
        {
            id: 2.5,
            label: "No middle name",
            name: "confirmedNoMiddleName",
            required: (state: any) => {
                return !state.middleName?.trim();
            },
            type: "checkbox",
            show: (state: any) => {
                return !state.isDrVenCol;
            },
        },
        {
            id: 3,
            label: "Last Name",
            name: "lastName",
            required: (state: any) => {
                return true;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
    ],
    2: [
        {
            id: 4,
            label: "Birth Date",
            name: "birthDate",
            required: (state: any) => {
                return true;
            },
            type: "date",
            show: (state: any) => {
                return true;
            },
        },
        {
            id: 5,
            label: "SSN",
            name: "ssn",
            required: (state: any) => {
                return state.isUnitedStates;
            },
            type: "ssn",
            show: (state: any) => {
                return state.isUnitedStates;
            },
        },
        {
            id: 5,
            label: "National ID",
            name: "nationalID",
            required: (state: any) => {
                return state.isDrVenCol;
            },
            type: "input",
            show: (state: any) => {
                return state.isDrVenCol;
            },
        },
        {
            id: 5,
            label: "ID",
            name: "japanID",
            required: (state: any) => {
                return state.isJapan;
            },
            type: "input",
            show: (state: any) => {
                return state.isJapan;
            },
        },
        {
            id: 6,
            label: "Position",
            name: "position",
            required: (state: any) => {
                return true;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
    ],
    3: [
        {
            id: 7,
            label: "Home Address",
            name: "homeAddress",
            required: (state: any) => {
                return true;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
    ],
    4: [
        {
            id: 8,
            label: "City",
            name: "city",
            required: (state: any) => {
                return true;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
        {
            id: 9,
            label: "State",
            name: "state",
            required: (state: any) => {
                return state.isUnitedStates;
            },
            options: usStatesOptions,
            type: "dropdown",
            show: (state: any) => {
                return state.isUnitedStates;
            },
        },
        {
            id: 9,
            label: "State/Province/Territory",
            name: "textInputState",
            required: (state: any) => {
                return !state.isUnitedStates;
            },
            type: "input",
            show: (state: any) => {
                return !state.isUnitedStates;
            },
        },
        {
            id: 10,
            label: "Zip Code",
            name: "zipCode",
            numsOnly: true,
            required: (state: any) => {
                return state.isUnitedStates;
            },
            type: "input",
            show: (state: any) => {
                return state.isUnitedStates;
            },
        },
        {
            id: 10,
            label: "Postal Code",
            name: "postalCode",
            required: (state: any) => {
                return !state.isUnitedStates;
            },
            type: "input",
            show: (state: any) => {
                return !state.isUnitedStates;
            },
        },
    ],
    5: [
        {
            id: 11,
            label: "Previous Address",
            name: "previousAddress",
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
    ],
    6: [
        {
            id: 12,
            label: "City",
            name: "previousCity",
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
        {
            id: 13,
            label: "State",
            name: "previousState",
            required: (state: any) => {
                return false;
            },
            options: usStatesOptions,
            type: "dropdown",
            show: (state: any) => {
                return state.isUnitedStates;
            },
        },
        {
            id: 13,
            label: "State/Province/Territory",
            name: "textInputPreviousState",
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return !state.isUnitedStates;
            },
        },
        {
            id: 14,
            label: "Zip Code",
            name: "previousZipCode",
            numsOnly: true,
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return state.isUnitedStates;
            },
        },
        {
            id: 14,
            label: "Postal Code",
            name: "previousPostalCode",
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return !state.isUnitedStates;
            },
        },
    ],
    7: [
        {
            id: 15,
            label: "Phone Number",
            name: "phoneNumber",
            required: (state: any) => {
                return true;
            },
            type: "input",
            show: (state: any) => {
                return true;
            },
        },
        {
            id: 16,
            label: "Driver's License",
            name: "driversLicenseState",
            required: (state: any) => {
                return false;
            },
            options: usStatesOptions,
            type: "dropdown",
            show: (state: any) => {
                return state.isUnitedStates;
            },
        },
        {
            id: 16,
            label: "Driver's License",
            name: "driversLicenseState",
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return !state.isUnitedStates;
            },
        },
        {
            id: 17,
            label: "Driver's License Number",
            name: "driversLicenseNumber",
            numsOnly: true,
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return state.isUnitedStates;
            },
        },
        {
            id: 17,
            label: "Personal Identification Number",
            name: "driversLicenseNumber",
            numsOnly: true,
            required: (state: any) => {
                return false;
            },
            type: "input",
            show: (state: any) => {
                return !state.isUnitedStates;
            },
        },
    ],
    8: [
        {
            id: 18,
            label: "add additional search names",
            name: "additionalSearchNames",
            required: (state: any) => {
                return false;
            },
            type: "link",
            show: (state: any) => {
                return true;
            },
        },
    ],
    9: [
        {
            id: 19,
            label: "Have you lived in any country other than the one you currently reside in?",
            name: "livedInOtherCountry",
            required: (state: any) => {
                return true;
            },
            type: "radio",
            dependencies: [
                "otherCountryLivedIn",
                "otherCountryLivedInFrom",
                "otherCountryLivedInTo",
                "otherCountryLivedInWhere",
            ],
            show: (state: any) => {
                return true;
            },
        },
    ],
    10: [
        {
            id: 20,
            label: "Country",
            name: "otherCountryLivedIn",
            required: (state: any) => {
                return state.livedInOtherCountry;
            },
            type: "input",
            show: (state: any) => {
                return state.livedInOtherCountry;
            },
        },
        {
            id: 21,
            label: "From",
            name: "otherCountryLivedInFrom",
            required: (state: any) => {
                return state.livedInOtherCountry;
            },
            type: "input",
            show: (state: any) => {
                return state.livedInOtherCountry;
            },
        },
        {
            id: 22,
            label: "To",
            name: "otherCountryLivedInTo",
            required: (state: any) => {
                return state.livedInOtherCountry;
            },
            type: "input",
            show: (state: any) => {
                return state.livedInOtherCountry;
            },
        },
    ],
    11: [
        {
            id: 23,
            label: "Where in the country did you live?",
            name: "otherCountryLivedInWhere",
            required: (state: any) => {
                return state.livedInOtherCountry;
            },
            type: "input",
            show: (state: any) => {
                return state.livedInOtherCountry;
            },
        },
    ],
};

export const PersonnelInfoDrVenColRow = [
    {
        id: 1,
        label: "Middle Name",
        name: "middleName",
        required: (state: any) => {
            return false;
        },
        type: "input",
        show: (state: any) => {
            return state.isDrVenCol;
        },
    },
    {
        id: 2.5,
        label: "No middle name",
        name: "confirmedNoMiddleName",
        required: (state: any) => {
            return !state.middleName?.trim();
        },
        type: "checkbox",
        show: (state: any) => {
            return state.isDrVenCol;
        },
    },
    {
        id: 2,
        label: "Mother's Maiden Name",
        name: "maidenName",
        required: (state: any) => {
            return false;
        },
        type: "input",
        show: (state: any) => {
            return state.isDrVenCol;
        },
    },
];

export const PERSONNEL_INFO_LAYOUT_ROWS_AMT = 11;
